/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import "./PlugOnlyNote.css";

/* The two words the sentence hands to something other than plain text. Split
   on both at once rather than in sequence, so neither locale's word order has
   to match English's -- zh and cn put the link last and the emphasis first. */
const TOKENS = /(\{channels\}|\{checkplus\})/;

/**
 * "This page counts Plug money only", under the dashboard's other two cards.
 *
 * A nonprofit running both products sees a smaller number here than it knows
 * it raised: every figure on this dashboard is its Plug payments, and its
 * CheckPlus donations are filtered out server-side and again on the way in.
 * Nothing on the page said so, which leaves the organisation to conclude
 * either that its month was bad or that Plug has lost something.
 *
 * The quietest of the three cards on purpose. PayoutAlert reports money not
 * arriving and ProfileNudge asks for something; this corrects an impression,
 * and blue is the interface's own colour rather than a state.
 */
class PlugOnlyNote extends Component {
  render() {
    const note = this.props.note;
    if (!note) {
      return null;
    }
    return (
      <div className="Marketplace-PlugOnlyNote">
        <span className="Marketplace-PlugOnlyNote-mark" aria-hidden="true">
          i
        </span>
        <div className="Marketplace-PlugOnlyNote-body">
          {(note.body || "").split(TOKENS).map((part, i) => {
            if (part === "{channels}") {
              return (
                <strong className="Marketplace-PlugOnlyNote-em" key={i}>
                  {note.channels}
                </strong>
              );
            }
            if (part === "{checkplus}") {
              return (
                /* Leaves Plug for the other product, so the opener does not
                   travel with it. */
                <a
                  className="Marketplace-PlugOnlyNote-link"
                  href={note.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={i}
                >
                  {note.link}
                </a>
              );
            }
            return <React.Fragment key={i}>{part}</React.Fragment>;
          })}
        </div>
      </div>
    );
  }
}

PlugOnlyNote.propTypes = {
  /* null for anyone whose dashboard is not a nonprofit's Plug-only figures. */
  note: PropTypes.object,
};

export default PlugOnlyNote;
